import template from './productAndLenderRationale.html';
import controller from './productAndLenderRationaleCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    loanAppId: '<',
    validateLoanDetails: '&',
    loanAppFormWarning: '<',
    fundingQuestionList: '<',
    loanAppOptions: '<',
    borrowingCapacity: '<',
  },
};
